import { render } from "./PatientContent.vue?vue&type=template&id=9f9ac7a0"
import script from "./PatientContent.vue?vue&type=script&lang=js"
export * from "./PatientContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rswenson/code/arch/surfacing/src/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__